// extracted by mini-css-extract-plugin
export default {"rfIdDetailsRow":"new-rfid_rfIdDetailsRow__ZKa9N"};